import { useState, useEffect } from "react";
import { Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import { get, getFile } from "utils/WebService";
import { errorAlert, successAlert } from "utils/Functions";
import { useMaterialUIController } from "context";

export default function ExportarPrestacaoContas() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [dataInicial, setDataInicial] = useState("");
    const [dataFinal, setDataFinal] = useState("");
    const [cliente, setCliente] = useState(null);
    const [clientesList, setClientesList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        get("/pessoa/list-all")
            .then(res => setClientesList(res.list || res || []))
            .catch(() => setClientesList([]));
    }, []);

    const handleExportar = () => {
        if (!cliente) {
            errorAlert("Por favor, selecione um Cliente.");
            return;
        }
        if (!dataInicial || !dataFinal) {
            errorAlert("Por favor, selecione a data inicial e final.");
            return;
        }

        setLoading(true);
        
        const clienteId = cliente.id || cliente.cvId;
        const url = `/relatorios/prestacao-contas/exportar?dataInicial=${dataInicial}&dataFinal=${dataFinal}&clienteId=${clienteId}`;
        const fileName = `Prestacao_Contas_${dataInicial}_a_${dataFinal}.xlsx`;

        getFile(url, fileName)
            .then(() => {
                successAlert("Exportação realizada com sucesso!");
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                errorAlert("Erro ao exportar Prestação de Contas.");
                setLoading(false);
            });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card
                    variant="outlined"
                    sx={{
                        p: 2,
                        mb: 2,
                        background: darkMode ? "#23233a" : "#fff",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <MDBox p={1} pb={2} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" color={darkMode ? "white" : "dark"}>
                            Exportar Prestação de Contas (PC)
                        </MDTypography>
                    </MDBox>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ px: 1, pb: 0.3, display: "block" }}>
                                Cliente / Credor
                            </MDTypography>
                            <MDSelect
                                isMulti={false}
                                name="cliente"
                                placeholder="Selecione um cliente..."
                                value={cliente}
                                options={clientesList}
                                getOptionValue={(option) => option.id || option.cvId}
                                getOptionLabel={(option) => option.nomeComum || option.nomeCompleto || option.nome || ""}
                                onChange={(val) => setCliente(val)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ px: 1, pb: 0.3, display: "block" }}>
                                Data Inicial do Pagamento
                            </MDTypography>
                            <MDTextFieldCalendar
                                type="date"
                                value={dataInicial}
                                onChange={(e) => setDataInicial(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                darkMode={darkMode}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ px: 1, pb: 0.3, display: "block" }}>
                                Data Final do Pagamento
                            </MDTypography>
                            <MDTextFieldCalendar
                                type="date"
                                value={dataFinal}
                                onChange={(e) => setDataFinal(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                darkMode={darkMode}
                            />
                        </Grid>

                        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1.5} pt={1.5}>
                            <MDButton 
                                variant="contained" 
                                color="info" 
                                size="small"
                                onClick={handleExportar}
                                disabled={loading}
                            >
                                {loading ? "Gerando..." : <><Icon sx={{ mr: 1 }}>download</Icon> Baixar Planilha (Excel)</>}
                            </MDButton>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
        </Grid>
    );
}
